const Request = require('./BaseRequest')
const ContentGraph = require('../graph/ContentGraph')

module.exports = class ContentRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new ContentGraph(this.apiDomain)
    }

    async articles(optional={})
    {
        let args = {...optional}
        let { type, query } = this.graph.articlesQuery([
            'id', 'title', 'content', 'theExcerpt', 'tagline', 'type', 'typeLabel', 'featureImg', 'theThumbnail', 'slug', 'data',
            { category: [ 'name', 'short_name', 'slug' ] }, 'is_read', 'is_watched', 'is_downloaded', 'watched_data'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async article(slug,country)
    {
        let args = {slug: slug, country: country}
        let { type, query } = this.graph.articleQuery([
            'id', 'type', 'typeLabel', 'title', 'tagline', 'content', 'featureImg', 'theExcerpt', 'featureImg', 'theThumbnail', 'publish_start', 'data', 'slug',
            { category: [
                'id', 'name', 'slug', { parent: [ 'name', 'slug' ] }
            ]}, 'is_read', 'is_watched', 'is_downloaded', 'watched_data'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    async category(section, slug)
    {
        let args = {section: section, slug: slug}
        let { type, query } = this.graph.categoryQuery([
            'id', 'name', 'thumbnail', 'slug'
        ])
        let data = await this.graph.request(query, args, type)
        return data
    }

    swrArticle(slug,country)
    {
        let args = {slug: slug, country: country}
        let { type, query } = this.graph.articleQuery([
            'id', 'title', 'content', 'tagline', 'theThumbnail', 'theExcerpt', 'slug', 'data', 'is_read', 'is_watched', 'is_downloaded', 'watched_data'
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrArticles(optional={})
    {
        let args = {...optional}
        let { type, query } = this.graph.articlesQuery([
            'id', 'title', 'content', 'tagline', 'type', 'typeLabel', 'theThumbnail', 'theExcerpt', 'slug', 'data',
            { category: [ 
                'short_name', 'name', 'slug', { parent: [ 'short_name', 'slug' ] } 
            ]}, 'is_read', 'is_watched', 'is_downloaded', 'watched_data'
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrCategory(section, slug)
    {
        let args = {section: section, slug: slug}
        let { type, query } = this.graph.categoryQuery([
            'id', 'name', 'thumbnail', 'slug'
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrCategories(optional={})
    {
        let args = {...optional}
        let { type, query } = this.graph.categoriesQuery([
            'id', 'name', 'thumbnail', 'slug'
        ], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrContentDetails(content_id,optional={})
    {
        let args = {content_id: content_id, ...optional}
        let { type, query } = this.graph.contentDetailsQuery([
            'id', 'content_id', 'user_id', 'contact_id', 'is_read', 'is_watched', 'is_downloaded', 'misc_data'
        ], args)

        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    //Save content Details
    async saveContentDetails(content_id, optional={})
    {
        let args = {content_id: content_id, ...optional}
        let { type, query } = this.graph.submitDetailsMutation(['id', 'content_id', 'user_id', 'contact_id', 'is_read', 'is_watched', 'is_downloaded','misc_data'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }


}